<template>
    <div class="columns mx-0">
        <div class="container pb-6 page">
            <div class="content pb-6">
                <h3 class="title mt-6">Offres d'emploi</h3>
                <b-message>Cliquez sur le symbole <b-icon
                icon="chevron-right"
                size="is-normal">
            </b-icon> au début de chaque ligne pour voir le détail.<br>Pour nous faire parvenir une offre d'emploi, veuillez <router-link to="/page/emploi/soumettre">cliquer ici</router-link>.</b-message>
                <b-table  v-if="!loading && nres>0" :data="joblist" :columns="columns" :icon-pack="iconPack" detailed>

                    <template #detail="props">
                        <div class="has-text-right mt-1 mb-5 is-size-7">
                            <i>Annonce postée le <span v-html="props.row._created"></span></i>
                            <br><i>Email de contact : <a :href="`mailto:${props.row.apply_email}`"><span v-html="props.row.apply_email"></span></a> </i>
                        </div>
                        <div class="has-background-white box mb-5" style="border-left: 8px solid royalblue;">
                            <p v-html="cleanMessage(props.row.contenu)"></p>
                        </div>
                    </template>
                </b-table>

                <div v-if="!loading && nres==0">Aucune offre d'emploi disponible actuellement</div>
            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
const moment = require('moment');
export default {
    data: function() {
        return {
            maintitle: 'Liste des offres',
            iconPack: 'mdi',
            error: null,
            success: null,
            page: true,
            loading: true,
            nres: 0,
            joblist: [],
            showDetailIcon: true,
            at: moment().format('DD MMM, YYYY'),
            columns: [{
                    field: 'titre',
                    label: 'Titre',
                    width: '400',
                },
                {
                    field: 'type_contrat',
                    label: 'Type de contrat',
                    searchable: true,
                },
                {
                    field: 'structure',
                    label: 'Hôpital/Service',
                    searchable: true,
                },
                {
                    field: 'region',
                    label: 'Département / Ville',
                    searchable: true,
                },

                {
                    field: 'startdate',
                    label: 'Date prise de fonction',
                }
            ]
        }
    },
    name: 'Jobs',
    props: {
        msg: String
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        cleanMessage(msg) {
          return this.$sanitize(msg);
        },
        fetchData() {
            this.error = this.joblist = null
            this.loading = true
            var vm = this
            var gte = moment().subtract(130, 'days').unix()
            var fetchurl = this.$api_url_jobs+'&sort[_created]=-1&filter[_created][$gte]='+gte
            axios({
                    method: 'get',
                    url: fetchurl,
                    /*headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        sort: { _created: -1 },
                        filter: {
                            _created: {
                                $gte: moment().subtract(365, 'days').unix()
                             }
                          }
                    })*/
                })
                .then(function(response) {
                    vm.loading = false
                    vm.joblist = response.data.entries
                    vm.nres = vm.joblist.length
                    vm.joblist.forEach(element => (element._created = moment.unix(element._created).format("DD/MM/YYYY")));

                })
                .catch(function() {
                    vm.error = 'erreur'
                })
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (max-width: 415px) {
    .page {
        min-height: 150px;
        margin-bottom: 20px;
        margin-top: 20px;
        padding: 10px;
    }
}
</style>